<template>

  <div class="tableContainerLucas">

    <div class="customSearchContainer">
      <div class="searchCriteriaDropdownContainer">
        <label :for="inputId" id="stID" class="form-label">Search Type</label>
        <select type="select" class="form-select-bs" @keydown.enter="CriteriaDropdownChanged($event)" @change="CriteriaDropdownChanged($event)" v-model="selectedCriteria" aria-labelledby="stID">
          <option value="-1">Select Search Type</option>
          <option value="1">Search by Person Info</option>
          <option value="2">Search by Contract Info</option>
        </select>
      </div>
      
      <button class="btn btn-primary" id="searchButton" @click="GetSearchDetails">Search</button>
    </div>
    

  <table :id="'table_' + id" class="display dtLucas compact" width="100%">
      <thead>
        <tr class="trclass">
          <th v-for="column in columnListPretty" :key="column" class="thclass">
            {{ column }}
          </th>

          <slot name="extraColumnHeaders">

          </slot>
          
          <th class="nosort actionHeader" ref="actionHeader" v-if="showActionColumn">Actions</th>
        </tr>
      </thead>
  
      <tbody>
        <tr v-for="row in loadedData" :key="row[columnNameId]">
          <td class="tdclass" v-for="column in columnListDB" :key="column">
            {{ row[column] }} 
          </td>


          <slot name="extraColumns" v-bind="row"></slot>

          <slot name="actionColumnEditSlot" v-bind="row" v-if="showActionColumn">

            <router-link :to="{ name: editRouteName, params: { id: row[columnNameId] } }" class="btn btn-primary editButton">Edit</router-link>

          </slot>

        </tr>
      </tbody>
    </table> 

  </div>
  
 
    
  </template>
  
<script>
  import $ from "jquery";
  import LoadingGif from "@/components/dataSupport/LoadingGif.vue";
  import { uuid } from "vue-uuid";
  import { ajaxDeleteHelper } from "../helpers/utilities";
  import { store } from "../../store/store.js";
  import "datatables.net-dt/js/dataTables.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";
  import "datatables.net-datetime";
  import "datatables.net-searchbuilder-dt";
  import "datatables.net-searchbuilder-dt/css/searchBuilder.dataTables.min.css";

  window.jQuery = $; 
  
  export default {
    name: "DataTableComponent",
    data() {
      return {
        loading: true,
        allData:[],
        loadedData: [],
        dt: null,
        id: null,
        store,
        componentKey:uuid.v1(),
        dtSettings:{},
        searchCriteria:{},
        preloadedSearchCriteria:{},
        selectedCriteria:1
      };
    },
    props: {
      // list of column names as they appear on the DB/ how they will be returend by an AJAX call
      columnListDB: Array,
      // list of column names as we want them to appear to the user
      columnListPretty: Array,
      // url to retrieve data set
      dataUrl: String,
      // the route name of the edit page for a particular data item
      editRouteName: String,
      // the name identifier for the ID used by this table (for deleting, and editing)
      columnNameId: String,
      // the url of the ajax delete method for this table
      deleteActionUrl: String,
      showActionColumn:{
        type:Boolean, 
        default:true
      },
      centerColumnIndexes:{
        type:Array,
        default:new Array(),
      },
      dateColumnIndexes:{
        type:Array,
        default: new Array(),
      },
      orderColumnIndex:{
        type:Number, 
        default:0,
      },
      orderDirection:{
        type:String,
        default:"asc",
      },
      showSearch:{
        type:Boolean, 
        default:true
      },
      showPaging:{
        type:Boolean, 
        default:true
      },
      showInfo:{
        type:Boolean, 
        default:true
      },
      rowsPerPage:{
        type:Number,
        default:10
      },
      showLengthChange:{
        type:Boolean,
        default:true
      },
      pluralDataName:{
        type:String,
        default:"entries"
      },
    },
    computed:{

    },
    async created(){

      //default criteria
      if(this.store.tempSearchCriteria != null){
        this.preloadedSearchCriteria = this.store.tempSearchCriteria; 
      }
      else{
        this.preloadedSearchCriteria = {
            criteria: [
                {
                    data: 'First Name',
                    condition: 'contains',
                    value: [''],
                    type:"string"
                },
                {
                    data: 'Last Name',
                    condition: 'contains',
                    value: [''],
                    type:"string"
                },
                {
                  data: 'Middle Name',
                  condition: 'contains',
                  value: [''],
                  type:'string'
              },
                {
                    data: 'Nationality',
                    condition: 'contains',
                    value: [''],
                    type:'string'
                }
            ],
            logic: 'AND'
        };
      }
    

      this.dtSettings = {
        "pageLength":this.rowsPerPage, 
        "lengthChange":this.showLengthChange,
        "columnDefs": [ 
          {
            "targets": 'nosort',
            "orderable": false
          } ,
          {
            "targets": "nosearch",
            "searchable": false
          },
          {
            "targets": this.dateColumnIndexes,
            "type": "date"
          },
          {
            "targets": this.centerColumnIndexes,
            "className": "tdCenter"
          }
        ],
        "deferRender": true,
        "scroller": true,
        "order": [this.orderColumnIndex, this.orderDirection],
        "searching": this.showSearch,
        "paging": this.showPaging,
        "info": this.showInfo,
        "lengthMenu":[
          [10,25,50,100,250,-1],
          [10,25,50,100,250,'All']
        ],
        "language":{
          "info": "Showing _START_ to _END_ of _TOTAL_ " + this.pluralDataName,
          "infoEmpty": "Showing 0 of 0 " + this.pluralDataName,
          "lengthMenu": "Show _MENU_ " + this.pluralDataName,
          "search": "Search " + this.pluralDataName,
          "zeroRecords": this.pluralDataName != "" ? "No matching " + this.pluralDataName + " found." : "No matching records found.",
          "infoFiltered": "(filtered from _MAX_ total " + this.pluralDataName + ")",
          "searchBuilder":{
            logicAnd: "Match All",
            logicOr:"Match Any"
          }
        },
        "dom": "Qlfrtip",
        "searchBuilder":{
          depthLimit:1,
          conditions:{
            string: {
              '=':null,
              '!=':null,
              '!null':null,
              'null':null,
              '!starts':null,
              'ends':null,
              "!ends":null,
              "!contains":null
            },
            num: {
              '=':null,
              '!=':null,
              '!null':null,
              'null':null,
              '!starts':null,
              'ends':null,
              "!ends":null,
              "!contains":null
            },
            html: {
              '=':null,
              '!=':null,
              '!null':null,
              'null':null,
              '!starts':null,
              'ends':null,
              "!ends":null,
              "!contains":null
            }
          },
          "preDefined": this.preloadedSearchCriteria
        }
      };
      
  
      this.loading = true; 

      //this.LoadDataAndInitializeTable();
      this.$nextTick(() => {
        console.log(this.dtSettings);
          this.dt = $("#table_" + this.id).DataTable(this.dtSettings).draw();
          $('.dtsb-logicContainer').css('width', '140px').css('left', '-100px').css('top', '35px');
          $('.dtsb-group').css('min-height','140px');
          $('.dtsb-searchBuilder').css('width','680px');
          $('.dtsb-value.dtsb-input').css('width', '90%');
        });
    },
    methods: {
      //load user2 data via ajax get request
      LoadData: async function (url) {

        var urlToUse = url;
        if(url == null)
          urlToUse = this.dataUrl;

        this.id = this.componentKey;

        this.store.tempSearchCriteria = this.searchCriteria; 
        //get data from specified url:
        var dataToRetrieve = await $.ajax({
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(this.searchCriteria),
          url: urlToUse,
          //to change when we start protecting the API endpoints
          xhrFields: {
            withCredentials: false,
          },
          success: (result) => {
            //console.log("Load Data called and completed: ", result);
            this.allData = result; 
            //set loaded data to the first 'page' of data-- this allows the Datatable to render quickly while the remaining
            //data renders in the background after the first page
            this.loadedData = result.slice(0,this.rowsPerPage);
            //this.loadedData = result; //<----- loading all data here results in additional time to render the table
            this.loading = false;
            
            this.$emit("dtDataLoaded");
          },
        });

        return dataToRetrieve;
      },
      ReloadTable(){
        this.dt.ajax.reload(null,false);
      },
      //when the delete button is hit on the data row
      DeleteItem(id) {
        //console.log("delete item: " + id);
        var deleteUrl = this.deleteActionUrl + id;
        ajaxDeleteHelper(deleteUrl, (result) => {
          result;
          //console.log("deleted item via ajax", result);
          this.LoadData(); 
        });
      },
      LoadDataAndInitializeTable: async function (url) {
        //-------------------------------------------------------grab all data
        var dataToRetrieve = await this.LoadData(url);
        this.loadedData = dataToRetrieve;
      },
      GetSearchDetails: function(){
        var criteria = this.dt.searchBuilder.getDetails(true);

        this.searchCriteria = criteria;
        this.store.tempSearchCriteria = criteria; 
        this.LoadDataAndInitializeTable();
      },
      CriteriaDropdownChanged: function(event){

        console.log("searchType changing");

        var eventTargetValue = event.target.value; 
        var newCriteria = {};
        switch(eventTargetValue){
          case "1": 
          newCriteria = {
            criteria: [
              {
                  data: 'First Name',
                  condition: 'contains',
                  value: [''],
                  type:'string'
              },
              {
                  data: 'Last Name',
                  condition: 'contains',
                  value: [''],
                  type:'string'
              },
              {
                  data: 'Middle Name',
                  condition: 'contains',
                  value: [''],
                  type:'string'
              },
              {
                  data: 'Nationality',
                  condition: 'contains',
                  value: [''],
                  type:'string'
              }
            ],
            logic: 'AND'
          };
          break;

          case "2":
              newCriteria = {
              criteria: [
                  {
                      data: 'Contract Number',
                      condition: 'contains',
                      value: [''],
                      type:'string'
                  },
              ],
          }; 
          break;
        }

        if(this.dt != null){ // destroys the datatable and resets TH widths to default
          this.dt.destroy();
          $("#table_" + this.id + " th").css('width','auto');
        }
        this.$nextTick(() => {
          this.dt = $("#table_" + this.id).DataTable(this.dtSettings).draw();
          console.log("search criteria: ", newCriteria); 
          this.dt.searchBuilder.rebuild(newCriteria);
          this.preloadedSearchCriteria = newCriteria; 

          var blah = this.dt.searchBuilder.getDetails(true);
          //console.log("what do I want?", newCriteria)
          //console.log("what is the table saying? ",blah);
          console.log("dtSettings: ", this.dtSettings);
        
          $('.dtsb-logicContainer').css('width', '140px').css('left', '-100px').css('top', '35px');
          $('.dtsb-group').css('min-height','140px');
          $('.dtsb-searchBuilder').css('width','680px');
          $('.dtsb-value.dtsb-input').css('width', '90%');
        });
      }
    },
    //watch the loaded data variable-- if it's changed, reload the data table
    watch: {
      loadedData(val) {
        val;
        console.log("loaded data changed ****************WATCH  ***********");
        if(this.dt != null){ // destroys the datatable and resets TH widths to default
          this.dt.destroy();
          $("#table_" + this.id + " th").css('width','auto');
        }
        
        //console.log("setting up DT triggered by loadedData watch variable");
        //then render the new datatable using the initial settings:
        this.$nextTick(() => {

          this.dt = $("#table_" + this.id).DataTable(this.dtSettings).draw();
          console.log("search criteria: ", this.preloadedSearchCriteria); 
          if(this.store.tempSearchCriteria == null)
            this.dt.searchBuilder.rebuild(this.preloadedSearchCriteria);
          else
            this.dt.searchBuilder.rebuild(this.store.tempSearchCriteria);

            var blah = this.dt.searchBuilder.getDetails(true);
          //console.log("what is the table saying? ",blah);
          console.log("dtsettings: ", this.dtSettings);

          $('.dtsb-logicContainer').css('width', '140px').css('left', '-100px').css('top', '35px');
          $('.dtsb-group').css('min-height','140px');
          $('.dtsb-searchBuilder').css('width','680px');
          $('.dtsb-value.dtsb-input').css('width', '90%');
        });
        
      },
    },
  
    components: { 
      LoadingGif 
    },
    emits:["dtUnmounted","dtDataLoaded"],
    beforeUnmount(){
      //console.log("Unmounting dt. Let's destroy table with id: ", this.id); 
      if ($.fn.DataTable.isDataTable("#table_" + this.id)) {
          $("#table_" + this.id)
            .DataTable()
            .destroy(); 
        }
      this.$emit("dtUnmounted"); 
      
    }
  };
  </script>
  
  <style scoped>
  .editButton {
    margin-right: 10px;
  }
  .dtLucas {
      font-size: 14px;
  }
  .thclass{
    font-size:8px;
    word-break: break-word;
    white-space: nowrap;
  }
  
  .tdclass {
    text-align:left;
    min-width:65px;
  }
  .tdCenter{
    text-align:center;
  }
  .actionColumn{
    min-width: 120px;
  }
  .forIconEdit{
    margin-right:15px;
  }
  .dataTables_wrapper{
    display:flex;
    flex-direction: column;
  }
  th{
    font-size:12px !important;
    max-width:400px; 
    text-align:center !important;
  }
  :slotted(th){
    min-width:50px !important;
    font-size:12px !important;
    text-align:center !important;
  }
  :slotted(.actionColumn){
    min-width: 120px;
  }
  :slotted(.forIconEdit){
    margin-right:15px;
  }
  .tableContainerLucas{
    width:100%;
  }
  .dataTables_wrapper .dataTables_filter input{
    background-color:white;
    opacity:85%;
  }
  .customSearchContainer{
    display:flex;
  }
  #searchButton{
    height: 50%;
    align-self:flex-end;
  }

  .dtsb-group{
    min-height:250px !important;
  }
  .dtsb-searchBuilder{
    width:590px !important;
  }
  div.dtsb-value dtsb-input{
    width:90%;
  }
  </style>
  